import React, { useMemo, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
} from "reactstrap";

const PaginationCommon = ({ metaData, params, setParams }) => {
  const [isOpenChangeSizePage, setIsOpenChangeSizePage] = useState(false);
  const changingPage = page => {
    setParams(prev => ({
      ...prev,
      page,
    }));
  };

  const changeingPerPage = size => {
    setParams(prev => ({
      ...prev,
      sizePerPage: size,
    }));
  };

  const pageRender = useMemo(() => {
    const pages = [];
    const indexPage =
      metaData.pageCount <= 5
        ? 1
        : metaData.currentPage < 3
        ? 1
        : metaData.currentPage < metaData.pageCount - 2
        ? metaData.currentPage - 2
        : metaData.pageCount - 4;
    const lastRenderPage =
      metaData.pageCount < 5 ? metaData.pageCount : indexPage + 4;
    const countRender =
      lastRenderPage <= metaData.pageCount
        ? lastRenderPage
        : metaData.pageCount;

    for (let index = indexPage; index <= countRender; index++) {
      pages.push(
        metaData.currentPage === index ? (
          <PaginationItem active>
            <PaginationLink href="#">{index}</PaginationLink>
          </PaginationItem>
        ) : (
          <PaginationItem>
            <PaginationLink href="#" onClick={() => changingPage(index)}>
              {index}
            </PaginationLink>
          </PaginationItem>
        )
      );
    }

    return (
      <>
        <PaginationItem disabled={metaData.currentPage < 2}>
          <PaginationLink first href="#" onClick={() => changingPage(1)} />
        </PaginationItem>
        <PaginationItem disabled={metaData.currentPage < 2}>
          <PaginationLink
            href="#"
            previous
            onClick={() => changingPage(metaData.currentPage - 1)}
          />
        </PaginationItem>
        {pages}
        <PaginationItem disabled={metaData.currentPage === metaData.pageCount}>
          <PaginationLink
            href="#"
            next
            onClick={() => changingPage(metaData.currentPage + 1)}
          />
        </PaginationItem>
        <PaginationItem disabled={metaData.currentPage === metaData.pageCount}>
          <PaginationLink
            href="#"
            last
            onClick={() => changingPage(metaData.pageCount)}
          />
        </PaginationItem>
      </>
    );
  }, [metaData]);

  return (
    <Card>
      <CardBody style={{ minWidth: "700px" }}>
        <Row>
          <Col className="text-start">
            <div style={{ width: "fit-content" }}>
              <Dropdown
                isOpen={isOpenChangeSizePage}
                toggle={() => setIsOpenChangeSizePage(prev => !prev)}
              >
                <DropdownToggle className="btn primary-btn w-100" caret>
                  {params.sizePerPage}
                  <i className="mdi mdi-chevron-down" />
                </DropdownToggle>
                <DropdownMenu className="w-100">
                  {[10, 20, 30, 40, 50].map(size => (
                    <DropdownItem
                      key={`${size}`}
                      onClick={() => changeingPerPage(size)}
                    >
                      {size}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </div>
          </Col>
          <Col>
            <Pagination
              className="d-flex justify-content-end"
              aria-label="Page navigation example"
            >
              {pageRender}
            </Pagination>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default PaginationCommon;
